import type { ActiveIntegrationConnection } from 'services/integration-service';

export type TeamsConnectionConfig = {
  azureTenantId: string;
  microsoftAppId: string;
  clientSecret: string;
  clientSecretExpiresAt: string;
  botName: string;
  azureBotResourceName: string;
};

export const getTeamsChatUrl = (connection?: ActiveIntegrationConnection | null) => {
  if (!connection) return null;
  if (connection.connection_url) return connection.connection_url;

  const botLink = connection.external_refs?.teams?.bot_link;
  if (botLink) return botLink;

  const appId =
    connection.external_refs?.teams?.microsoft_app_id ||
    connection.bot_id ||
    null;
  if (appId) {
    return `https://teams.microsoft.com/l/chat/0/0?users=28:${appId}`;
  }

  return null;
};

export const EMPTY_TEAMS_CONFIG: TeamsConnectionConfig = {
  azureTenantId: '',
  microsoftAppId: '',
  clientSecret: '',
  clientSecretExpiresAt: '',
  botName: '',
  azureBotResourceName: '',
};

export const isTeamsConfigComplete = (config: TeamsConnectionConfig) =>
  Object.values(config).every((value) => value.trim().length > 0);
